import { csrfToken } from "@root/shared/utils/csrf";
import { type ReactNode, type RefObject, useMemo } from "react";

type Step1FormProps = {
  formRef: RefObject<HTMLFormElement>;
  action: string;
  emailValue: string;
  passwordValue: string;
  children?: ReactNode;
};

export const Step1HiddenForm = (props: Step1FormProps) => {
  const { formRef, action, emailValue, passwordValue, children } = props;

  const authenticityToken = useMemo(() => csrfToken(), []);

  return (
    <form ref={formRef} action={action} acceptCharset="UTF-8" method="post">
      <input type="hidden" name="authenticity_token" value={authenticityToken} />
      <input
        type="hidden"
        name="form_user_frontend_user_registration_step1[email]"
        value={emailValue}
      />
      <input
        type="hidden"
        name="form_user_frontend_user_registration_step1[password]"
        value={passwordValue}
      />
      {children}
    </form>
  );
};
